<div *ngIf="!hideCifScreen">
    <h1>Demo CIF CREATION scenarios</h1>
    <div class="d-flex" style="gap: 10px">
        <button (click)="cifCreated('success')" type="button" class="btn btn-primary">cif creation success</button>
        <button (click)="cifCreated('failed')" type="button" class="btn btn-primary">cif creation failed</button>
    </div>
</div>

<div *ngIf="cifCreatedFlag">
    <h1>Demo DM response scenarios</h1>
    <div class="d-flex" style="gap: 10px">
        <button (click)="dmResponse('success')" type="button" class="btn btn-primary">DM response success</button>
        <button (click)="dmResponse('failed')" type="button" class="btn btn-primary">DM response failed</button>
    </div>
</div>